"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var userRouter = {
  path: '/user',
  component: _layout.default,
  redirect: '/user/index',
  name: 'User',
  meta: {
    title: '用户',
    icon: 'clipboard'
  },
  children: [{
    path: 'index',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/user/list/index'));
      });
    },
    name: 'UserIndex',
    meta: {
      title: '会员列表',
      icon: ''
    }
  }, {
    path: 'grade',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/user/grade/index'));
      });
    },
    name: 'Grade',
    meta: {
      title: '等级设置',
      icon: ''
    }
  }, {
    path: 'bankList',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/user/bankList/index'));
      });
    },
    name: 'bankList',
    meta: {
      title: '提款信息',
      icon: ''
    }
  }, {
    path: 'realName',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/user/realName/index'));
      });
    },
    name: 'RealName',
    meta: {
      title: '实名信息',
      icon: ''
    }
  }, {
    path: 'flowing',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/user/flowing/index'));
      });
    },
    name: 'Flowing',
    meta: {
      title: '流水记录',
      icon: ''
    }
  }, {
    path: 'loginLog',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/user/loginLog/index'));
      });
    },
    name: 'loginLog',
    meta: {
      title: '登录记录',
      icon: ''
    }
  }, {
    path: 'recharge',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/user/recharge/index'));
      });
    },
    name: 'Recharge',
    meta: {
      title: '充值记录',
      icon: ''
    }
  }, {
    path: 'withdrawal',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/user/withdrawal/index'));
      });
    },
    name: 'Withdrawal',
    meta: {
      title: '提现记录',
      icon: ''
    }
  }, {
    path: 'yuebao',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/user/yuebao/index'));
      });
    },
    name: 'Yuebao',
    meta: {
      title: '余额宝理财',
      icon: ''
    }
  }, {
    path: 'yuebaoOrder',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/user/yuebaoOrder/index'));
      });
    },
    name: 'YuebaoOrder',
    meta: {
      title: '余额宝订单',
      icon: ''
    }
  }, {
    path: 'yuebaoTotal',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/user/yuebaoTotal/index'));
      });
    },
    name: 'yuebaoTotal',
    meta: {
      title: '余额宝结算',
      icon: ''
    }
  }, {
    path: 'relationships',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/user/relationships/index'));
      });
    },
    name: 'relationships',
    meta: {
      title: '会员关系网',
      icon: ''
    }
  }, {
    path: 'label',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/user/group/index'));
      });
    },
    name: 'Label',
    meta: {
      title: '用户标签',
      icon: ''
    }
  }, {
    path: 'group',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/user/group/index'));
      });
    },
    name: 'Group',
    meta: {
      title: '用户分组',
      icon: ''
    }
  }]
};
var _default = userRouter;
exports.default = _default;